import { BakeryPdf417 } from '@barcode-bakery/barcode-react/pdf417';

const  Pdf417 = ({id='12AA0101'})=> {
  return (

   <>
    <div className = 'row text-center mt-2'>
        <div className ='mx-auto'>
            <BakeryPdf417 
                text   = {id} 
                scale  = {1.5}
            />
        </div>
    </div>
    <div class ='row text-center'>
           <span className ='mx-auto'>库位:{id}</span>
    </div>
   </>

);
}

export default Pdf417;

